export default "__VITE_ASSET__BKDCqita__"